import { request } from "../@utils";
const SupplierService = {
  create: (data) => {
    return request.post("supplier/create", { data })
  },
  update: (data) => {
    return request.post("supplier/update", { data });
  },
  page: ({
    contactName,
    merchantCode,
    supplierId,
    validity,
    pageIndex = 1,
    pageSize = 10,
  } = {}) => {
    return request.post("supplier/page", {
      data: {
        contactName,
        merchantCode,
        pageIndex,
        pageSize,
        supplierId,
        validity,
      },
    });
  },
  detail: ({ id }) => {
    return request.get(`supplier/detail/${id}`);
  },
  updateStatus: ({ id, validity }) => {
    return request.post(`supplier/update-status`, { data: { id, validity } });
  },
};

export default SupplierService;
